export const organizationEventSelectStyle = {
	wrapper: {
		maxWidth: '275px',
		minWidth: '0px',
		width: '100%',

		'@media (max-width: 639.98px)': {
			minWidth: '100%',
		},

		'& .MuiInputBase-root': {
			borderRadius: '8px',
			background: 'var(--background-grey-op-50-1)',
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			zIndex: '-1',
		},
		'& .MuiFormControl-root .MuiInputBase-input': {
			color: 'var(--neutral-900)',
		},
	},
};
